import { render } from "./DeleteRecordPopUp.vue?vue&type=template&id=0525b0da&scoped=true"
import script from "./DeleteRecordPopUp.vue?vue&type=script&lang=js"
export * from "./DeleteRecordPopUp.vue?vue&type=script&lang=js"

import "./DeleteRecordPopUp.vue?vue&type=style&index=0&id=0525b0da&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0525b0da"]])

export default __exports__